import type { KeyboardEvent } from 'react';

import { handleListFocusKey } from '@/utils/listFocusKeys';

// Radix renders a hidden native checkbox next to its button inside a form, so
// the selector names the button's role rather than any input.
const ITEM_SELECTOR = 'input[type="search"], [role="checkbox"]:not([disabled])';

function menuItems(menu: HTMLElement | null): HTMLElement[] {
    return menu ? Array.from(menu.querySelectorAll<HTMLElement>(ITEM_SELECTOR)) : [];
}

/**
 * Arrow keys move between the search field and the checkboxes and wrap at
 * either end, Home and End jump to the ends, and Enter toggles the focused
 * checkbox as it would a menu item. Escape is Menu's: it closes the list.
 */
export function handleMenuKey(event: KeyboardEvent<HTMLElement>, menu: HTMLElement | null): void {
    if (handleListFocusKey(event, menuItems(menu))) return;
    if (event.key !== 'Enter') return;
    // Keeps Enter in the search field from submitting a surrounding form.
    // Radix ignores Enter on a checkbox, as a native one does.
    event.preventDefault();
    const { target } = event;
    if (target instanceof HTMLElement && target.getAttribute('role') === 'checkbox') {
        target.click();
    }
}
